export const myActionType = "[action type]";



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js


// WEBPACK FOOTER //
// webpack:///src/actions/actionTypes.js